import type { HTMLAttributes, ReactNode } from 'react';

import { classNames } from '@movingimage-evp/mi-ui-component-library';

import styles from './post-live-event-infobox.module.css';

export type PostLiveEventInfoboxProps = {
  icon?: ReactNode;
  title?: string;
  value?: string | number;
  placeholder?: string;
  metricType?: string;
} & HTMLAttributes<HTMLDivElement>;

/**
 * @param {ReactNode} [icon] Icon to be display.
 * @default undefined
 * @param {string} [title] Title of the element.
 * @default undefined
 * @param {string} [value] Value of to the element.
 * @default undefined
 * @param {string} [placeholder] Placeholder to be displayed if value is not available.
 * @default undefined
 */
export function PostLiveEventInfobox({
  className,
  icon,
  title,
  value,
  placeholder,
  metricType,
  ...props
}: PostLiveEventInfoboxProps) {
  const baseTestId = metricType ? `post-live-event-infobox-${metricType}` : 'post-live-event-infobox';

  return (
    <div className={classNames(styles.wrapper, className)} data-testid={baseTestId} {...props}>
      <div className={styles.title} data-testid={`${baseTestId}-title`}>
        {icon}
        {title}
      </div>

      {placeholder ? (
        <span data-testid={`${baseTestId}-placeholder`} className={styles.placeholder}>
          {placeholder}
        </span>
      ) : (
        <span data-testid={`${baseTestId}-value`} className={styles.value}>
          {value}
        </span>
      )}
    </div>
  );
}
